import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-sidebar-message',
  templateUrl: './sidebar-message.component.html',
  styleUrls: ['./sidebar-message.component.sass']
})
export class SidebarMessageComponent implements OnInit, OnDestroy {
  public total = 3;
  public slide = 1;
  public currentSlide = this.slide;
  public timer = null;

  constructor() { }

  ngOnInit() {
    this.startTimer();
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }

  changeSlide(nb) {
    this.currentSlide = nb;

    clearInterval(this.timer);
    this.startTimer();
  }

  startTimer() {
    this.timer = setInterval(() => {
      this.slide++;

      if (this.slide > this.total) {
        this.slide = 1;
      }

      this.changeSlide(this.slide);
    }, 5000);
  }
}
